import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

type PageHeadProps = {
  title?: string;
  titleId?: string;
  description?: string;
  descriptionId?: string;
  canonicalPath?: string;
  canonicalUrl?: string;
  children?: React.ReactNode;
};

const APP_TITLE_ID = 'application_title';

const PageHead: React.FC<PageHeadProps> = ({
  title,
  titleId,
  description,
  descriptionId,
  canonicalPath,
  canonicalUrl,
  children,
}) => {
  const intl = useIntl();
  const location = useLocation();

  const formatLabel = (id?: string) =>
    id
      ? intl.formatMessage({
          id,
        })
      : '';

  const appTitle = formatLabel(APP_TITLE_ID) || 'DID';
  const pageTitle = title || formatLabel(titleId);
  const metaDescription = description || formatLabel(descriptionId);
  const canonicalHref =
    canonicalUrl ||
    `${window.location.origin}${canonicalPath || location.pathname}`;
  const fullTitle = pageTitle ? `${pageTitle}` : appTitle;

  return (
    <Helmet>
      <html lang={intl.locale} />
      <title>{fullTitle}</title>
      {metaDescription && (
        <meta
          name="description"
          content={metaDescription}
        />
      )}
      <link
        rel="canonical"
        href={canonicalHref}
      />
      {children}
    </Helmet>
  );
};

export default PageHead;
